module.exports = __webpack_public_path__ + "0d8462c3e8689b76840cd1a2d993ff77.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/business-suit.png
// module id = 1813
// module chunks = 0